export function shouldShowInvoicingNotAvailable({
    isInvoicingAvailable,
    isInternalInvoicingRegion,
    invoiceProvider,
}: {
    isInvoicingAvailable: boolean;
    isInternalInvoicingRegion: boolean;
    invoiceProvider?: string | null;
}): boolean {
    return (
        !isInvoicingAvailable ||
        (isInternalInvoicingRegion && invoiceProvider === 'internal')
    );
}
